import { Link } from "react-router-dom";
import { UserSocialLinks } from "../data/applications/Users";

const SocialLinks = () => {

  return (
    <ul className="card-social">
      {UserSocialLinks.map((data, index) => (
        <li key={index}>
          <Link to={data.link} target="_blank">
            <i className={`${data.icon} me-0`}></i>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default SocialLinks;